var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqIcon = function SvgFaqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9698 4.88C13.3389 4.88 14.4329 5.25334 15.2517 6C16.0839 6.74667 16.5 7.76667 16.5 9.06001C16.5 10.4067 16.0705 11.42 15.2114 12.1C14.3523 12.78 13.2114 13.12 11.7886 13.12L11.7081 14.7H9.71476L9.61409 11.56H10.2785C11.5805 11.56 12.5738 11.3867 13.2584 11.04C13.9564 10.6933 14.3054 10.0333 14.3054 9.06001C14.3054 8.35334 14.0973 7.80001 13.6812 7.4C13.2785 7.00001 12.7148 6.80001 11.9899 6.80001C11.2651 6.80001 10.6946 6.99334 10.2785 7.38C9.86242 7.76667 9.65436 8.30667 9.65436 9.00001H7.5C7.5 8.20001 7.68121 7.48667 8.04362 6.86001C8.40604 6.23334 8.92282 5.74667 9.59396 5.40001C10.2785 5.05334 11.0705 4.88 11.9698 4.88ZM10.6812 19.12C10.2651 19.12 9.91611 18.98 9.63423 18.7C9.35235 18.42 9.21141 18.0733 9.21141 17.66C9.21141 17.2467 9.35235 16.9 9.63423 16.62C9.91611 16.34 10.2651 16.2 10.6812 16.2C11.0839 16.2 11.4262 16.34 11.7081 16.62C11.9899 16.9 12.1309 17.2467 12.1309 17.66C12.1309 18.0733 11.9899 18.42 11.7081 18.7C11.4262 18.98 11.0839 19.12 10.6812 19.12Z",
    fill: "#999999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#999999",
    strokeWidth: 2
  })));
};
export default SvgFaqIcon;